import { IconHeading } from '@tabler/icons-react'

import { HeadingDisplayBlock as RenderHeadingDisplayBlock } from '../../templateRenderer/DisplayBlocks/HeadingDisplayBlock'
import { HeadingDisplayBlock } from '../../types/blueprint'

import {
  BaseBlockConfig,
  Field,
  FORBIDDEN_IN_APP,
  InputField,
  SelectField,
  TypeOption,
} from './_BaseBlockConfig'

class Config extends BaseBlockConfig<HeadingDisplayBlock> {
  public override kind = 'display' as const
  public override type = 'heading' as const

  public override blockTypeConfig: TypeOption = {
    kind: this.kind,
    value: this.type,
    label: 'Heading',
    icon: IconHeading,
    hideName: true,
    hideDescription: true,
    forbiddenTemplateTypes: FORBIDDEN_IN_APP,
  }

  public override blockFieldsConfig: Field[] = [
    {
      name: 'content',
      label: 'Heading value',
      field: InputField,
      required: true,
    },
    {
      name: 'size',
      label: 'Size',
      field: SelectField,
      options: [
        { value: 'H1', label: 'Extra large' },
        { value: 'H2', label: 'Large' },
        { value: 'H3', label: 'Medium', default: true },
        { value: 'H4', label: 'Small' },
        { value: 'H5', label: 'Extra small' },
      ],
      required: true,
    },
  ]

  public override mapFormValueToBlock(
    block: HeadingDisplayBlock
  ): HeadingDisplayBlock {
    return block
  }

  public override renderBlock(block: HeadingDisplayBlock): React.ReactNode {
    return <RenderHeadingDisplayBlock block={block} />
  }
}

export const HeadingDisplayBlockConfig = new Config()
